import { AxiosResponse } from 'axios';
import { HomeDisplayBanner } from 'src/admin-entity/interface/home-display/home-display-banner.interface';
import { Page } from 'src/admin-entity/interface/page/page-info.interface';
import { BASE_URL } from 'src/config/api';
import client from '../client';

export const getBannerList = (page: number, take: number): Promise<AxiosResponse<Page<HomeDisplayBanner>>> =>
    client.get(`${BASE_URL}/v1/admin/banner?page=${page}&take=${take}`);

export const getBannerDetail = (bannerId: number): Promise<AxiosResponse<HomeDisplayBanner>> =>
    client.get(`${BASE_URL}/v1/admin/banner/${bannerId}`);

export const updateBannerBasicInfo = (banner: HomeDisplayBanner): Promise<AxiosResponse<boolean>> =>
    client.put(`${BASE_URL}/v1/admin/banner/${banner.id}/base`, banner);

export const updateBannerDetail = (banner: HomeDisplayBanner): Promise<AxiosResponse<boolean>> =>
    client.put(`${BASE_URL}/v1/admin/banner/${banner.id}/detail`, banner);

export const updateBannerFile = (
    bannerId: number,
    data: FormData,
    setProgress: (value: any) => void,
): Promise<AxiosResponse<boolean>> =>
    client.put(`${BASE_URL}/v1/admin/banner/${bannerId}/file`, data, {
        onUploadProgress: (e: ProgressEvent) => {
            setProgress(Math.floor((e.loaded / e.total) * 100));
        },
    });

export const searchBannerList = (
    take: number,
    status: string,
    linkType: string,
    title: string,
    bannerType?: string,
): Promise<AxiosResponse<Page<HomeDisplayBanner>>> => {
    const url = new URL(`${BASE_URL}/v1/admin/banner`);
    url.searchParams.set(`page`, `0`);
    url.searchParams.set('take', `${take}`);
    if (title) {
        url.searchParams.set('title', title);
    }
    if (status !== 'all') {
        url.searchParams.set('status', status);
    }
    if (linkType !== 'all') {
        url.searchParams.set('linkType', linkType);
    }
    if (bannerType !== 'all' && bannerType !== undefined) {
        url.searchParams.set('bannerType', bannerType);
    }

    return client.get(`${url.toString()}`);
};

export const createBanner = (
    data: FormData,
    setProgress: (value: any) => void,
): Promise<AxiosResponse<HomeDisplayBanner>> =>
    client.post(`${BASE_URL}/v1/admin/banner`, data, {
        onUploadProgress: (e: ProgressEvent) => {
            setProgress(Math.floor((e.loaded / e.total) * 100));
        },
    });

export const deleteBanner = (bannerId: number): Promise<AxiosResponse<boolean>> =>
    client.delete(`${BASE_URL}/v1/admin/banner/${bannerId}`);
